import bee from "./Bee";
export default{
    name: "Signup",
        /*
        var query = {
            first_name: "",
            last_name: "",
            email: "",
            country: "",
            password: ""
        }
    */
    /* eslint-disable no-unused-vars */
    signup(query, success, fail) {
        //var token = bee.token;
        var email = query.email;
        if(email.indexOf("@") < 0){ 
            //get the last eight digits
            email = email.substr(-8,8);
        }
        bee.token = null;
        bee.que()
        .get({
            users:{
                _w: [
                    [
                        [ "email", "e", email], 
                        "AND",
                        [ "email_address", "e", email]
                    ] 
                ]
            }
        },"unique_query")
        .post({
            _f_signup: {
                user :{
                    first_name: query.first_name,
                    last_name: query.last_name,
                    date_of_birth: "1969-05-02",
                    profile_picture: "\/dist\/img\/user-placeholder.png",
                    gender: "male",
                    email: query.email,
                    country_id: query.country,
                    county_id: "",
                    national_id: "XXXX",
                    passport: "XXX",
                    email_address: query.email,
                    password: query.password,
                    name: query.first_name + " " + query.last_name,
                    district_id: 1,
                    city_id: 1,
                    plot_number: "xxxxx"
                },
                as : "owner"
            }
        },"signup_query")
        .before("signup_query",(index, previous_res, tasks)=>{
            // console.log("index", index);
            //console.log("previous_res", previous_res.users.length);
            // console.log("tasks", tasks);
            if(previous_res.users.length > 0){
                tasks[index].errors.push("Phone number/ Email is already in use");
                return false;
            }
            return tasks[index].nectar;
        })
        .send().then(res => {
            //console.log("res of signup: ", res);
            success(res);
        }).catch(errors => {
            //console.log("errors of signup: ", errors);
            fail(errors);
        });

       
    }
}